module.exports = __webpack_public_path__ + "img/loginimg.add8710f.png";